import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { fuseConfig } from 'app/fuse-config';
import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { LoginModule } from './main/auth/login.module';
import { AuthStoreModule } from './main/auth/store/store.module';
import { Store, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { authReducer } from './main/auth/store/auth.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './main/auth/store/auth.effects';
import { AuthInterceptorService } from './main/auth/auth-interceptor.service';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRippleModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { NGRX_AUTO_ENTITY_APP_STORE, NgrxAutoEntityModule } from '@briebug/ngrx-auto-entity';
import { AuthGuard } from './shared/service/auth-guard.service';
import { Error404Component } from './main/pages/errors/404/error-404.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MonitoringComponent } from './main/monitoring/monitoring.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DatePipe } from '@angular/common';
import { SimpleDialogFormComponent } from './shared/simple-dialog-form/simple-dialog-form.component';
import { AppConfigService } from './shared/service/app-config.service';
import { environment } from 'environments/environment';
import { SpinnerModule } from './main/pages/spinner/spinner.module';
import { PrivilegeEnum } from './main/privilege/privilege.enum';
import { NotificationsModule } from './shared/notifications/notifications.module';
import { QualisysProfileComponent } from './main/qualisys-profile/qualisys-profile-form/qualisys-profile.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
const appRoutes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: 'monitoring',
        component: MonitoringComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./main/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'profile',
        loadChildren: () => import('./main/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [AuthGuard],
    },
    /*************PARAMETRAGE APP********************************/
    {
        path: 'rappels',
        loadChildren: () => import('./main/rappel/rappel.module').then(m => m.RappelModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GENERAL }
    },
    {
        path: 'processus',
        loadChildren: () => import('./main/processus/processus.module').then(m => m.ProcessusModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GENERAL }
    },
    {
        path: 'pays',
        loadChildren: () => import('./main/pays/pays.module').then(m => m.PaysModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GENERAL }
    },
    {
        path: 'villes',
        loadChildren: () => import('./main/ville/ville.module').then(m => m.VilleModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GENERAL }
    },
    {
        path: 'options-generales',
        loadChildren: () => import('./main/parametres-generaux/parametres-generaux.module').then(m => m.ParametresGenerauxModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GENERAL }
    },
    {
        path: "actionlogs",
        loadChildren: () =>
            import("./main/actionlog/actionlog.module").then(
                (m) => m.ActionLogModule
            ),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GENERAL }
    },
    {
        path: 'notification-chat',
        loadChildren: () => import('./main/notification-chat/notification-chat.module').then(m => m.NotificationChatModule),
        canActivate: [AuthGuard],
    },
    /* {
        path: 'qualisys-profile',
        component: QualisysProfileComponent
    }, */
    {
        path: 'qualisys-profile',
        loadChildren: () => import('./main/qualisys-profile/qualisys-profile.module').then(m => m.QualisysProfileModule),
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GENERAL }

    },




    /*************PARAMETRAGE APP********************************/
    /*************CONTROLE ACCES********************************/
    {
        path: 'users',
        loadChildren: () => import('./main/user/user.module').then(m => m.UserModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.CONTROLE_ACCES }
    },
    {
        path: 'roles',
        loadChildren: () => import('./main/role/role.module').then(m => m.RoleModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.CONTROLE_ACCES }
    },
    {
        path: 'groupes',
        loadChildren: () => import('./main/groupe/groupe.module').then(m => m.GroupeModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.CONTROLE_ACCES }
    },
    /*************CONTROLE ACCES********************************/
    /*************GRH********************************/
    {
        path: 'types-diplomes',
        loadChildren: () => import('./main/type-diplome/type-diplome.module').then(m => m.TypeDiplomeModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE_ETUDE_UNIVERSITAIRE }
    },
    {
        path: 'etablissements',
        loadChildren: () => import('./main/etablissement/etablissement.module').then(m => m.EtablissementModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE_ETUDE_UNIVERSITAIRE }
    },
    {
        path: 'specialites',
        loadChildren: () => import('./main/specialite/specialite.module').then(m => m.SpecialiteModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE_ETUDE_UNIVERSITAIRE }
    },
    {
        path: 'domaines-competence',
        loadChildren: () => import('./main/domaine-competence/domaine-competence.module').then(m => m.DomaineCompetenceModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE_ETUDE_UNIVERSITAIRE }
    },
    {
        path: 'question',
        loadChildren: () => import('./main/batterie-questions/question/question.module').then(m => m.QuestionModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE_COMPETENCE }
    },
    {
        path: 'competences',
        loadChildren: () => import('./main/competence/competence.module').then(m => m.CompetenceModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE_COMPETENCE }
    },
    {
        path: 'actions-formation',
        loadChildren: () => import('./main/action-formation/action-formation.module').then(m => m.ActionFormationModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE_COMPETENCE }
    },
    {
        path: 'criteres-maintien',
        loadChildren: () => import('./main/critere-maintien/critere-maintien.module').then(m => m.CritereMaintienModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE_COMPETENCE }
    },
    {
        path: 'services',
        loadChildren: () => import('./main/service/service.module').then(m => m.ServiceModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE_SERVICE }
    },
    {
        path: 'vaccinations',
        loadChildren: () => import('./main/vaccination/vaccination.module').then(m => m.VaccinationModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE_VACCINATION }
    },
    {
        path: 'evaluations',
        loadChildren: () => import('./main/evaluation/evaluation.module').then(m => m.EvaluationModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE }
    },
    {
        path: 'gestion-competences',
        loadChildren: () => import('./main/gestion-competence/gestion-competence.module').then(m => m.GestionCompetenceModule),
        canActivate: [AuthGuard],
        //data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE }
    },
    {
        path: 'diplomes',
        loadChildren: () => import('./main/diplome/diplome.module').then(m => m.DiplomeModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE }
    },
    {
        path: 'experiences',
        loadChildren: () => import('./main/experience/experience.module').then(m => m.ExperienceModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE }
    },
    {
        path: 'formations',
        loadChildren: () => import('./main/formation/formation.module').then(m => m.FormationModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RESSOURCE_HUMAINE }
    },
    {
        path: 'employes',
        loadChildren: () => import('./main/employe/employe-dto/employe-dto.module').then(m => m.EmployeDTOModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.RESSOURCE_HUMAINE_EMPLOYE }
    },
    {
        path: 'postes',
        loadChildren: () => import('./main/poste/poste-dto/poste-dto.module').then(m => m.PosteDTOModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.RESSOURCE_HUMAINE_FICHE_POSTE }
    },
    {
        path: 'questionnaires',
        loadChildren: () => import('./main/questionnaire/questionnaire.module').then(m => m.QuestionnaireModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.RESSOURCE_HUMAINE_QUESTIONNAIRE }
    },
    /*************GRH ********************************/
    /*************Amelioration Continue ********************************/
    {
        path: 'impacts',
        loadChildren: () => import('./main/impact/impact.module').then(m => m.ImpactModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AMELIORATION_CONTINUE }
    },
    {
        path: 'categories-emetteur',
        loadChildren: () => import('./main/categorie-emetteur/categorie-emetteur.module').then(m => m.CategorieEmetteurModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AMELIORATION_CONTINUE }
    },
    {
        path: 'incidences',
        loadChildren: () => import('./main/incidence/incidence.module').then(m => m.IncidenceModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AMELIORATION_CONTINUE }
    },
    {
        path: 'sites',
        loadChildren: () => import('./main/site/site.module').then(m => m.SiteModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AMELIORATION_CONTINUE }
    },
    {
        path: 'sujets',
        loadChildren: () => import('./main/sujet/sujet.module').then(m => m.SujetModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AMELIORATION_CONTINUE }
    },
    {
        path: 'etats-action',
        loadChildren: () => import('./main/etat-action/etat-action.module').then(m => m.EtatActionModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AMELIORATION_CONTINUE }
    },
    {
        path: 'frequences',
        loadChildren: () => import('./main/frequence/frequence.module').then(m => m.FrequenceModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AMELIORATION_CONTINUE }
    },
    {
        path: 'detectabilites',
        loadChildren: () => import('./main/detectabilite/detectabilite.module').then(m => m.DetectabiliteModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AMELIORATION_CONTINUE }
    },
    {
        path: 'question-enquete',
        loadChildren: () => import('./main/batterie-questions/question-enquete/question-enquete.module').then(m => m.QuestionEnqueteModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AMELIORATION_CONTINUE }
    },
    {
        path: 'preuves-efficacite',
        loadChildren: () => import('./main/preuve-efficacite/preuve-efficacite.module').then(m => m.PreuveEfficaciteModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AMELIORATION_CONTINUE }
    },
    {
        path: 'non-conformites',
        loadChildren: () => import('./main/non-conformite/non-conformite.module').then(m => m.NonConformiteModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.AMELIORATION_CONTINUE_NON_CONFORMITE }
    },
    {
        path: 'reclamations',
        loadChildren: () => import('./main/reclamation/reclamation.module').then(m => m.ReclamationModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.AMELIORATION_CONTINUE_RECLAMATION }
    },
    {
        path: 'taches-ouvertes',
        loadChildren: () => import('./main/action/action.module').then(m => m.ActionModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.AMELIORATION_CONTINUE_ACTION }
    },
    {
        path: 'calendar',
        loadChildren: () => import('./main/calendar/calendar.module').then(m => m.CalendarModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.AMELIORATION_CONTINUE_CALENDRIER }
    },
    {
        path: 'enquetes',
        loadChildren: () => import('./main/enquete/enquete.module').then(m => m.EnqueteModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.AMELIORATION_CONTINUE_ENQUETTE_SATISFACTION }
    },
    {
        path: 'enquete-publish/:id',
        loadChildren: () => import('./main/pages/enquete-publish/enquete-publish.module').then(m => m.EnquetePublishModule),
    },
    /*************Amelioration Continue ********************************/
    /*************GED********************************/
    {
        path: 'types-doc-externe',
        loadChildren: () => import('./main/type-doc-externe/type-doc-externe.module').then(m => m.TypeDocExterneModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GED }
    },
    {
        path: 'types-enregistrement',
        loadChildren: () => import('./main/type-enregistrement/type-enregistrement.module').then(m => m.TypeEnregistrementModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GED }
    },
    {
        path: 'origines-doc-externe',
        loadChildren: () => import('./main/origine-doc-externe/origine-doc-externe.module').then(m => m.OrigineDocExterneModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GED }
    },
    {
        path: 'parties-interessees',
        loadChildren: () => import('./main/partie-interessee/partie-interessee.module').then(m => m.PartieInteresseeModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GED }
    },
    {
        path: 'ged',
        loadChildren: () => import('./main/ged/ged.module').then(m => m.GEDModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GESTION_DOCUMENTAIRE }
    },
    {
        path: 'stat',
        loadChildren: () => import('./main/ged/ged-pages/stats/stat.module').then(m => m.STATModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GESTION_DOCUMENTAIRE }
    },
    {
        path: 'recent',
        loadChildren: () => import('./main/ged/ged-pages/recent_doc/recent.module').then(m => m.RECENTGedModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GESTION_DOCUMENTAIRE }
    },
    {
        path: 'doc-externes',
        loadChildren: () => import('./main/ged/ged-pages/ext-docs/doc-externe.module').then(m => m.DocExterneModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GESTION_DOCUMENTAIRE }
    },
    {
        path: 'formulaires',
        loadChildren: () => import('./main/ged/ged-pages/master-doc-ged/master-doc-ged.module').then(m => m.MasterDocGedModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GESTION_DOCUMENTAIRE }
    },
    {
        path: 'records',
        loadChildren: () => import('./main/ged/ged-pages/record/record.module').then(m => m.RecordModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GESTION_DOCUMENTAIRE }
    },
    {
        path: 'doc-templates',
        loadChildren: () => import('./main/ged/ged-pages/new-doc/doc-template/doc-template.module').then(m => m.DocTemplateModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GESTION_DOCUMENTAIRE }
    },
    {
        path: 'records-tracking',
        loadChildren: () => import('./main/record-tracking/record-tracking.module').then(m => m.RecordTrackingModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GESTION_DOCUMENTAIRE }
    },
    {
        path: 'records-papers',
        loadChildren: () => import('./main/record-paper/record-paper.module').then(m => m.RecordPaperModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GESTION_DOCUMENTAIRE }
    },
    {
        path: 'docs-interne',
        loadChildren: () => import('./main/doc-interne/doc-interne.module').then(m => m.DocInterneModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GESTION_DOCUMENTAIRE }
    },
    /*************GED ********************************/
    /*************INDICATEUR ********************************/
    {
        path: 'indicateurs',
        loadChildren: () => import('./main/indicateur/indicateur.module').then(m => m.IndicateurModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.INDICATEUR }
    },
    /*************INDICATEUR ********************************/
    /*************GMAO ********************************/
    {
        path: 'priorites',
        loadChildren: () => import('./main/priorite/priorite.module').then(m => m.PrioriteModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'typepannes',
        loadChildren: () => import('./main/typepanne/typepanne.module').then(m => m.TypePanneModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'taskpieces',
        loadChildren: () => import('./main/taskpiece/taskpiece.module').then(m => m.TaskPieceModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'typeinterventions',
        loadChildren: () => import('./main/typeintervention/typeintervention.module').then(m => m.TypeInterventionModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'typetacheinterventions',
        loadChildren: () => import('./main/typetacheintervention/typetacheintervention.module').then(m => m.TypeTacheInterventionModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'unitedurees',
        loadChildren: () => import('./main/uniteduree/uniteduree.module').then(m => m.UniteDureeModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'statuttaches',
        loadChildren: () => import('./main/statuttache/statuttache.module').then(m => m.StatutTacheModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'marques',
        loadChildren: () => import('./main/marque/marque.module').then(m => m.MarqueModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'models',
        loadChildren: () => import('./main/model/model.module').then(m => m.ModelModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'types',
        loadChildren: () => import('./main/type/type.module').then(m => m.TypeModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'etats',
        loadChildren: () => import('./main/etat/etat.module').then(m => m.EtatModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'champutilisations',
        loadChildren: () => import('./main/champutilisation/champutilisation.module').then(m => m.ChamputilisationModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'disciplines',
        loadChildren: () => import('./main/discipline/discipline.module').then(m => m.DisciplineModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'criticites',
        loadChildren: () => import('./main/criticite/criticite.module').then(m => m.CriticiteModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'emplacements',
        loadChildren: () => import('./main/emplacement/emplacement.module').then(m => m.EmplacementModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'fournisseurs',
        loadChildren: () => import('./main/fournisseur/fournisseur.module').then(m => m.FournisseurModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_GMAO }
    },
    {
        path: 'equipements',
        loadChildren: () => import('./main/equipement/equipement.module').then(m => m.EquipementModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GMAO_EQUIPEMENT }
    },
    {
        path: 'pannes',
        loadChildren: () => import('./main/panne/panne.module').then(m => m.PanneModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GMAO_PANNE }
    },
    {
        path: 'interventions',
        loadChildren: () => import('./main/intervention/intervention.module').then(m => m.InterventionModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GMAO_INTERVENTION }
    },
    {
        path: 'tasks',
        loadChildren: () => import('./main/task/task.module').then(m => m.TaskModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GMAO_TACHE }
    },
    {
        path: 'pieces',
        loadChildren: () => import('./main/piece/piece.module').then(m => m.PieceModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GMAO_PIECE }
    },
    {
        path: 'statuthistoriques',
        loadChildren: () => import('./main/statuthistorique/statuthistorique.module').then(m => m.StatutHistoriqueModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.GMAO }
    },
    /*******************************GMAO *******************************/
    /*******************************RISK ******************************/
    {
        path: "risks",
        loadChildren: () =>
            import("./main/risk/risk.module").then((m) => m.RiskModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.RISQUE }
    },
    {
        path: "high-risks",
        loadChildren: () =>
            import("./main/high-risk/high-risk.module").then((m) => m.HighRiskModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.RISQUE }
    },
    {
        path: "assessments-risk",
        loadChildren: () =>
            import("./main/assessment-risk/assessment-risk.module").then(
                (m) => m.AssessmentRiskModule
            ),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.RISQUE }
    },
    {
        path: "params",
        loadChildren: () =>
            import("./main/high-risk-param/highriskparam.module").then(
                (m) => m.HighRiskParamModule
            ),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RISQUE }
    },
    {
        path: "severities",
        loadChildren: () =>
            import("./main/severity/severity.module").then(
                (m) => m.SeverityModule
            ),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RISQUE }
    },
    {
        path: "criticalities",
        loadChildren: () =>
            import("./main/criticality/criticality.module").then(
                (m) => m.CriticalityModule
            ),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_RISQUE }
    },
    /***********************RISK *********************************/
    /***********************REVUE DE DIRECTION *********************************/
    {
        path: "revuedirections",
        loadChildren: () =>
            import("./main/revuedirection/revuedirection.module").then(
                (m) => m.RevueDirectionModule
            ),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.REVUE_DIRECTION }
    },



    /***********************REVUE DE DIRECTION *********************************/
    {
        path: 'audits',
        loadChildren: () => import('./main/audit/audits.module').then(m => m.AuditsModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.AUDIT }
    },
    {
        path: 'normes',
        loadChildren: () => import('./main/norme/norme.module').then(m => m.NormeModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AUDIT }
    },
    {
        path: 'chapitres',
        loadChildren: () => import('./main/chapitre/chapitre.module').then(m => m.ChapitreModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_AUDIT }
    },
    {
        path: 'notification-params',
        loadChildren: () => import('./main/notification-param/notification-param.module').then(m => m.NotificationParamModule),
        canActivate: [AuthGuard],
    },

    /***********************PROLAB STOCK *********************************/
    {
        path: 'articles',
        loadChildren: () => import('./main/article/article.module').then(m => m.ArticleModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_ARTICLE }
    },
    {
        path: 'stocks',
        loadChildren: () => import('./main/stock/stock.module').then(m => m.StockModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_LOT_STOCK }
    },
    {
        path: 'familles',
        loadChildren: () => import('./main/famille/famille.module').then(m => m.FamilleModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_STOCK }
    },
    {
        path: 'typearticles',
        loadChildren: () => import('./main/typearticle/typearticle.module').then(m => m.TypeArticleModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_STOCK }
    },
    {
        path: 'unites',
        loadChildren: () => import('./main/unite/unite.module').then(m => m.UniteModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_STOCK }
    },
    {
        path: 'contactfournisseurs',
        loadChildren: () => import('./main/contactfournisseur/contactfournisseur.module').then(m => m.ContactFournisseurModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_STOCK }
    },
    {
        path: 'demandeachats',
        loadChildren: () => import('./main/demandeachat/demandeachat.module').then(m => m.DemandeAchatModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_STOCK }
    },
    {
        path: 'fournisseurarticles',
        loadChildren: () => import('./main/fournisseurarticle/fournisseurarticle.module').then(m => m.FournisseurArticleModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_STOCK }
    },
    {
        path: 'bons',
        loadChildren: () => import('./main/bon/bon.module').then(m => m.BonModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_BON }
    },
    {
        path: 'bondetails',
        loadChildren: () => import('./main/bondetail/bondetail.module').then(m => m.BonDetailModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_BON }
    },
    {
        path: 'bonreceptions',
        loadChildren: () => import('./main/bonreception/bonreception.module').then(m => m.BonReceptionModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_BON }
    },
    {
        path: 'bonsorties',
        loadChildren: () => import('./main/bonsortie/bonsortie.module').then(m => m.BonSortieModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_BON }
    },
    {
        path: 'bonentrees',
        loadChildren: () => import('./main/bonentree/bonentree.module').then(m => m.BonEntreeModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_BON }
    },
    {
        path: 'bonretours',
        loadChildren: () => import('./main/bonretour/bonretour.module').then(m => m.BonRetourModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_BON }
    },
    {
        path: 'situationfournisseurs',
        loadChildren: () => import('./main/situation-fournisseur/situation-fournisseur.module').then(m => m.SituationFournisseurModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_SITUATION_FOURNISSEUR }
    },
    {
        path: 'inventaires',
        loadChildren: () => import('./main/inventaire/inventaire.module').then(m => m.InventaireModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_INVENTAIRE }
    },
    {
        path: 'inventairedetails',
        loadChildren: () => import('./main/inventairedetail/inventairedetail.module').then(m => m.InventaireDetailModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_INVENTAIRE }
    },
    {
        path: 'factures',
        loadChildren: () => import('./main/facture/facture.module').then(m => m.FactureModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_FACTURE }
    },
    {
        path: 'reglements',
        loadChildren: () => import('./main/reglement/reglement.module').then(m => m.ReglementModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_REGLEMENT }
    },
    {
        path: 'reglementpieces',
        loadChildren: () => import('./main/reglementpiece/reglementpiece.module').then(m => m.ReglementPieceModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_REGLEMENT }
    },
    {
        path: 'caisses',
        loadChildren: () => import('./main/caisse/caisse.module').then(m => m.CaisseModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_CAISSE }
    },
    {
        path: 'banques',
        loadChildren: () => import('./main/banque/banque.module').then(m => m.BanqueModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_STOCK }
    },
    {
        path: 'modepaiements',
        loadChildren: () => import('./main/modepaiement/modepaiement.module').then(m => m.ModePaiementModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_STOCK }
    },
    {
        path: 'facturedetails',
        loadChildren: () => import('./main/facturedetail/facturedetail.module').then(m => m.FactureDetailModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.STOCK_FACTURE }
    },
    /***********************DOCUMENTATION *********************************/
    {
        path: 'documentation',
        loadChildren: () => import('./main/documentation/documentation.module').then(m => m.DocumentationModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.DOCUMENTATION }
    },
    /***********************RATING *********************************/
    {
        path: 'ratings',
        loadChildren: () => import('./main/rating/rating.module').then(m => m.RatingModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.RATING }
    },
    /***********************COMPAGNE *********************************/
    {
        path: 'compagnes',
        loadChildren: () => import('./main/compagne/compagne.module').then(m => m.CompagneModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.COMPAGNE }
    },
    /***********************FEEDBACK *********************************/
    {
        path: 'feedback',
        loadChildren: () => import('./main/feedback/feedback.module').then(m => m.FeedbackModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.FEEDBACK }
    },
    /***********************FEEDBACK Admin *********************************/
    {
        path: 'compagnes-data',
        loadChildren: () => import('./main/compagnedata/compagnedata.module').then(m => m.CompagnedataModule),
        canActivate: [AuthGuard],
        //  data: { privilege: PrivilegeEnum.DOCUMENTATION }
    },
    {
        path: 'compagnes-stat',
        loadChildren: () => import('./main/compagnedata/stats/stat.module').then(m => m.COMPAGNESTATModule),
        canActivate: [AuthGuard],
        // data: { privilege: PrivilegeEnum.GESTION_DOCUMENTAIRE }
    },
    /*********************** TO DO *********************************/
    // {
    //     path: "todos",
    //     loadChildren: () =>
    //         import("./main/to-do/to-do.module").then(
    //             (m) => m.ToDoModule
    //         ),
    //     canActivate: [AuthGuard],
    //   //  data: { privilege: PrivilegeEnum.TODO }
    // },



    /***********************TO DO *********************************/

    /***********************EvaluationFrounisseur *********************************/

    {
        path: 'critereevaluationfournisseurs',
        loadChildren: () => import('./main/critereevaluationfournisseur/critereevaluationfournisseur.module').then(m => m.CritereEvaluationFournisseurModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.PARAMETRER_APP_EVALUATION_FOURNISSEUR }
    },
    {
        path: 'categoriefournisseurs',
        loadChildren: () => import('./main/categoriefournisseur/categoriefournisseur.module').then(m => m.CategorieFournisseurModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.EVAL_CATEGORIE_FOURNISSEUR }
    },
    {
        path: 'evaluationcategoriefournisseurs',
        loadChildren: () => import('./main/evaluationcategoriefournisseur/evaluationcategoriefournisseur.module').then(m => m.EvaluationCategorieFournisseurModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.EVAL_EVALUATION_CATEGORIE_FOURNISSEUR }
    },

    /***********************CALENDARTODO *********************************/
    {
        path: 'calendar-todo',
        loadChildren: () => import('./main/calendar-todo/todo.module').then(m => m.CalendarTaskModule),
        canActivate: [AuthGuard],
        data: { privilege: PrivilegeEnum.TODO }
    },



    /***********************EvaluationFrounisseur *********************************/
    {
        path: '403',
        component: Error404Component,
        data: {
            code: '403',
            title: 'Accès refusé',
            message: 'Vous n\'avez pas le droit d\'acceder'
        }
    },
    {
        path: '404',
        component: Error404Component,
        data: {
            code: '404',
            title: 'Page introuvable',
            message: 'La page que vous cherchez est introuvable'
        }
    },
    {
        path: '**',
        redirectTo: '404'
    },
];
@NgModule({
    declarations: [
        AppComponent,
        Error404Component,
        MonitoringComponent,
        SimpleDialogFormComponent,
        // NotificationsComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        NotificationsModule,
        RouterModule.forRoot(appRoutes),
        TranslateModule.forRoot(),
        // Material moment date module
        MatMomentDateModule,
        // Material
        MatButtonModule,
        MatIconModule,
        MatSnackBarModule,
        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        SpinnerModule,
        ToastModule,
        NgxChartsModule,
        // App modules
        LayoutModule,
        LoginModule,
        MatPaginatorModule,
        MatRippleModule,
        MatSelectModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        BrowserAnimationsModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatDialogModule,
        MatToolbarModule,
        AuthStoreModule,
        StoreModule.forRoot(authReducer),
        EffectsModule.forRoot([AuthEffects]),
        NgrxAutoEntityModule.forRoot(),
        StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
            logOnly: environment.production, // Restrict extension to log-only mode
        }),
    ],
    bootstrap: [
        AppComponent,
    ],
    providers: [
        AppConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: (cs: AppConfigService) => () => cs.load(),
            deps: [AppConfigService],
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (cs: AppConfigService) => () => cs.loadLoginApps(),
            deps: [AppConfigService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        },
        {
            provide: NGRX_AUTO_ENTITY_APP_STORE,
            useFactory: provideAppStore,
            deps: [Store]
        },
        MessageService,
        DatePipe,
    ]
})
export class AppModule {
}
export function provideAppStore(store: Store<any>) {
    return store;
}